import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue";
const _hoisted_1 = {
  key: 0
};
import { onMounted, ref } from "vue";
import AppLink from "./Link.vue";
import { isExternal } from "@/utils/validate";
export default {
  __name: 'MenuItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const onlyOneChild = ref(null);
    const hasOneShowingChild = (children = [], parent) => {
      const showingChildren = children.filter(i => {
        if (i.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          onlyOneChild.value = i;
          return true;
        }
      });
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }
      // Show parent if there are no child router to display
      if (!showingChildren.length) {
        onlyOneChild.value = {
          ...parent,
          path: "",
          noShowingChildren: true
        };
        return true;
      }
      return false;
    };
    const resolvePath = routePath => {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(props.basePath)) {
        return props.basePath;
      }
      // 去掉重复的 '/'，避免生成路径时重复
      const cleanBasePath = props.basePath.replace(/\/+$/, "");
      const cleanRoutePath = routePath.replace(/^\/+/, "");
      return `${cleanBasePath}/${cleanRoutePath}`.replace(/\/+$/, "");
    };
    onMounted(() => {});
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_MenuItem = _resolveComponent("MenuItem", true);
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      return !__props.item.hidden ? (_openBlock(), _createElementBlock("div", _hoisted_1, [hasOneShowingChild(__props.item.children, __props.item) && (!onlyOneChild.value?.children?.length || onlyOneChild.value.noShowingChildren) && !__props.item.alwaysShow ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [onlyOneChild.value.meta ? (_openBlock(), _createBlock(AppLink, {
        key: 0,
        to: resolvePath(onlyOneChild.value.path),
        meta: onlyOneChild.value.meta
      }, {
        default: _withCtx(({
          meta
        }) => [_createVNode(_component_el_menu_item, {
          index: resolvePath(onlyOneChild.value.path),
          class: _normalizeClass({
            'submenu-title-noDropdown': !__props.isNest
          })
        }, {
          default: _withCtx(() => [meta.icon ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0
          }, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(meta.icon)))]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_ctx.$t(`route.${meta.title}`)), 1)]),
          _: 2
        }, 1032, ["index", "class"])]),
        _: 1
      }, 8, ["to", "meta"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 1,
        index: resolvePath(__props.item.path),
        "popper-append-to-body": "",
        ref: "subMenu"
      }, {
        title: _withCtx(() => [__props.item.meta.icon ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(__props.item.meta.icon)))]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_ctx.$t(`route.${__props.item.meta.title}`)), 1)]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, subItem => {
          return _openBlock(), _createBlock(_component_MenuItem, {
            key: subItem.path,
            item: subItem,
            "is-nest": true,
            "base-path": resolvePath(subItem.path),
            class: "nest-menu"
          }, null, 8, ["item", "base-path"]);
        }), 128))]),
        _: 1
      }, 8, ["index"]))])) : _createCommentVNode("", true);
    };
  }
};